<template>
    <div id="wrapper" >
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.report.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    <div class="form-row">    
                        <div class="form-group col-md-12">
                            <div class="card-box">
                                <b-card no-body>
                                    <b-tabs fill active-nav-item-class="text-uppercase">
                                        <b-tab active>
                                            <template v-slot:title>
                                                <i class=""></i> <strong>{{'  '+ $t('string.msg.menu.register.trucker.withoutVehicle.label.title')}}</strong>
                                            </template>
                                            <WithoutVehicle />
                                        </b-tab>
                                    </b-tabs>
                                </b-card>
                            </div>
                            <!-- end card-box-->
                        </div> 
                        <!-- end col -->
                    </div>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>

import Controller from './CrtTrucker';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import WithoutVehicle from './WithoutVehicle/WithoutVehicle.vue';

export default {
    name: 'Request',
    components: {
    Spinner,
    Toast,
    WithoutVehicle,
    },
    data() {
        return {
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this);
    },
    mounted() {
    }
    }
    </script>

    <style>
    </style>
